import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
export type GetUpcomingProvidersQueryVariables = Types.Exact<{
	country: Types.Scalars['Country']['input'];
	pageType: Types.NewPageType;
	language: Types.Scalars['Language']['input'];
	first: Types.Scalars['Int']['input'];
}>;

export type GetUpcomingProvidersQuery = {
	__typename?: 'Query';
	newTitles: {
		__typename?: 'NewTitlesConnection';
		edges?: Array<{
			__typename?: 'NewTitlesEdge';
			node:
				| {
						__typename?: 'Movie';
						id: string;
						content: {
							__typename?: 'MovieContent';
							upcomingReleases: Array<{
								__typename?: 'UpcomingRelease';
								package?: { __typename?: 'Package'; id: string; packageId: number } | null;
							}>;
						};
				  }
				| {
						__typename?: 'Season';
						id: string;
						content: {
							__typename?: 'SeasonContent';
							upcomingReleases: Array<{
								__typename?: 'UpcomingRelease';
								package?: { __typename?: 'Package'; id: string; packageId: number } | null;
							}>;
						};
				  };
		}> | null;
	};
};

export const GetUpcomingProvidersDocument = gql`
	query GetUpcomingProviders($country: Country!, $pageType: NewPageType!, $language: Language!, $first: Int!) {
		newTitles(country: $country, pageType: $pageType, first: $first) {
			edges {
				node {
					id
					content(country: $country, language: $language) {
						upcomingReleases {
							package {
								id
								packageId
							}
						}
					}
				}
			}
		}
	}
`;
